// Shared, deduped fetch for /today/priorities (used by TopBar bell + Today feed).
let cache = null;
let fetchedAt = 0;
let inflight = null;
const TTL = 30000;

export function fetchPriorities(api) {
  const now = Date.now();
  if (cache && now - fetchedAt < TTL) return Promise.resolve(cache);
  if (inflight) return inflight;
  inflight = api.get('/today/priorities')
    .then(r => { cache = r.data; fetchedAt = Date.now(); return cache; })
    .finally(() => { inflight = null; });
  return inflight;
}
